import { yupResolver } from '@hookform/resolvers/yup';
import React, { FC, useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Modal } from 'react-bootstrap';
import { Language } from 'services/ApiService/Subscription/SubscriptionApiClient';
import { GB, FR, JP } from 'country-flag-icons/react/3x2';
import * as yup from 'yup';
import { useGetSettings, useSetLanguage } from 'queries/Settings/settings.queries';
import { Loading } from 'components/common/Loading';
import classNames from 'classnames';

export const LanguageSettings: FC<{ icId: string }> = ({ icId }) => {
    const [isOpen, setIsOpen] = useState(false);

    const { data: settings } = useGetSettings(icId);
    const { mutateAsync: setLanguage, isPending } = useSetLanguage(icId);

    const { register, handleSubmit, reset } = useForm({
        mode: 'all',
        defaultValues: {
            language: settings?.at(0)?.language || Language.English,
        },
        resolver: yupResolver(yup.object({
            language: yup.mixed<Language>()
                .oneOf(Object.values(Language))
                .required(),
        })),
    });
    useEffect(() => {
        reset({ language: settings?.at(0)?.language });
    }, [JSON.stringify(settings)]);

    const onSubmit: SubmitHandler<{
        language: Language;
    }> = async (data) => {
        const id = settings?.at(0)?.id;
        await setLanguage({ id: id || 0, body: { icId, language: data.language } });
        setIsOpen(false);
    };

    const onClose = () => {
        setIsOpen(false);
        reset();
    };

    return settings && settings.length > 0 && <>
        <button className="btn btn-lg btn-discreet-primary" onClick={() => setIsOpen(true)}>
            Language settings
        </button>
        <Modal show={isOpen} onHide={onClose}>
            <div className="modal-header">
                <h3 className="modal-title">
                    Language settings
                </h3>
                <button type="button" onClick={onClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <div className="d-flex flex-column gap-2">
                    <div className="text-secondary">
                        Please select below your language preference for publication you are subscribed to.
                    </div>
                    <div className="d-flex flex-column gap-1">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div data-toggle="buttons" role="group" aria-label="Basic radio toggle button group">
                                <div className="form-check">
                                    <input type="radio"
                                        {...register('language')}
                                        value={Language.English}
                                        className="form-check-input"
                                        id={`language_${Language.English}`} />
                                    <label className="form-check-label d-flex align-items-center gap-1" htmlFor={`language_${Language.English}`}>
                                        <GB style={{ height: '15px' }} /> English
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input type="radio"
                                        {...register('language')}
                                        value={Language.French}
                                        className="form-check-input"
                                        id={`language_${Language.French}`} />
                                    <label className="form-check-label d-flex align-items-center gap-1" htmlFor={`language_${Language.French}`}>
                                        <FR style={{ height: '15px' }} /> French (if available)
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input type="radio"
                                        {...register('language')}
                                        value={Language.Japanese}
                                        className="form-check-input"
                                        id={`language_${Language.Japanese}`} />
                                    <label className="form-check-label d-flex align-items-center gap-1" htmlFor={`language_${Language.Japanese}`}>
                                        <JP style={{ height: '15px' }} className="border" />  Japanese (if available)
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <button onClick={onClose} className="btn btn-flat-primary">
                                    Cancel
                                </button>
                                <button type="submit" className={classNames('btn btn-primary', { 'disabled': isPending })}>
                                    Save {isPending && <Loading className="spinner-sm ms-2" />}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal >
    </>;
};